import React from 'react';
import Header from '../components/Header';
import Footer from '../components/Footer';

const AboutPage = () => {
  return (
    <div id="main-wrapper">
      <Header />
      <div id="content" role="main">
        {/* Hero Section */}
        <section
    className="hero-wrap"
    style={{
    position: "relative",
    overflow: "hidden",
    minHeight: "60vh",
    display: "flex",
    alignItems: "center",
  }}
>
  {/* Background Video */}
  <video
    autoPlay
    loop
    muted
    playsInline
    style={{
      position: "absolute",
      top: 0,
      left: 0,
      width: "100%",
      height: "100%",
      objectFit: "cover",
      zIndex: 1,
    }}
  >
    {/* <source src="/images/projects/VIDEO RovoAutomation.mp4" type="video/mp4" /> */}
  </video>

  {/* Overlay (optional dark layer for text readability) */}
  <div
  style={{
    position: "absolute",
    top: 0,
    left: 0,
    width: "100%",
    height: "100%",
    backgroundImage: "url('/images/projects/AF.jpg')",
    backgroundRepeat: "no-repeat",    
    backgroundSize: "cover",           
    backgroundPosition: "center",      
    zIndex: 0,
  }}
></div>

  {/* Content */}
  <div
    className="container"
    style={{ position: "relative", zIndex: 3, paddingTop: "70px" }}
  >
    <div className="row">
      <div className="col-12 text-center text-white">
        <h1 className="text-16 text-white mb-3">About RovoAutomation</h1>
        <p className="lead text-white-100 mb-0">
          Pioneering IoT & Automation Solutions to operationalize the Industries of Tomorrow.
        </p>
      </div>
    </div>
  </div>
</section>


        {/* Company Overview */}
        <section className="section bg-white">
          <div className="container">
            <div className="row align-items-center">
              <div className="col-lg-6 mb-4 mb-lg-0 ">
                <img src="images/projects/about1.jpeg" alt="Team" className="img-fluid rounded shadow " />
              </div>
              <div className="col-lg-6 ">
                <h2 className="font-weight-600 mb-4">Who We Are</h2>
                <p className="text-3 mb-3">At Rovo Automation, we blend deep industrial domain expertise with cutting-edge digital technology to deliver truly integrated IT-OT-IoT automation solutions. We help industrial clients de-risk operations, maximize output, and ensure sustainable, data-driven growth in the Industry 4.0 era.</p>
                <p className="text-3 mb-4">Our mission is to be the most trusted and results-driven automation and digital transformation partner across India, empowering our clients by turning today's facilities into tomorrow's Lighthouse Factories and centers of data-driven operational excellence.</p>
               
              </div>
            </div>
          </div>
        </section>

        {/* Mission & Vision */}
        <section className="section bg-light">
          <div className="container">
            <div className="row">
              <div className="col-lg-6 mb-4 mb-lg-0">
                <div className="bg-white p-5 rounded shadow-sm h-100">
                  <div className="text-primary mb-3">
                 
                  </div>
                  <h3 className="font-weight-600 mb-3">Our Mission</h3>
                  <p className="text-3 mb-0">To elevate manufacturing excellence by seamlessly fusing real-time machine data, human expertise, and modern digital technologies.</p>
                </div>
              </div>
              <div className="col-lg-6">
                <div className="bg-white p-5 rounded shadow-sm h-100">
                  <div className="text-primary mb-3">
                    
                  </div>
                  <h3 className="font-weight-600 mb-3">Our Vision</h3>
                  <p className="text-3 mb-0">To be recognized as India’s leading and most trusted Industrial Automation and Digital Transformation partner, enabling smart, sustainable factories, truly data-driven operations, and world-class manufacturing excellence across every industrial sector.</p>
                </div>
              </div>
            </div>
          </div>
        </section>

        {/* Core Values */}
       <section className="section bg-white">
    <div className="container">
        <div className="row">
            <div className="col-lg-8 mx-auto text-center mb-5">
                <h2 className="font-weight-600 mb-3">Our Core Values</h2>
                <hr className="heading-separator-line border-primary border-2 d-block mx-auto" />
            </div>
        </div>
        <div className="row">
            
            {/* 1. Innovation */}
            <div className="col-md-6 col-lg-3 mb-4">
                <div className="text-center">
                    <div className="text-primary mb-3">
                      
                        <i className="fas fa-lightbulb fa-2x"></i>
                    </div>
                    <h4 className="font-weight-600 mb-2">Innovation</h4>
                    <p className="text-3 mb-0">Proactively delivering cutting-edge, future-proof solutions.</p>
                </div>
            </div>
            
            {/* 2. Excellence */}
            <div className="col-md-6 col-lg-3 mb-4">
                <div className="text-center">
                    <div className="text-primary mb-3">
                       
                        <i className="fas fa-award fa-2x"></i>
                    </div>
                    <h4 className="font-weight-600 mb-2">Excellence</h4>
                    <p className="text-3 mb-0">Committed to the highest standards of reliability and performance.</p>
                </div>
            </div>
            
            {/* 3. Integrity */}
            <div className="col-md-6 col-lg-3 mb-4">
                <div className="text-center">
                    <div className="text-primary mb-3">
                     
                        <i className="fas fa-handshake fa-2x"></i>
                    </div>
                    <h4 className="font-weight-600 mb-2">Integrity</h4>
                    <p className="text-3 mb-0">Building absolute trust through complete transparency and ethics.</p>
                </div>
            </div>
            
            {/* 4. Collaboration */}
            <div className="col-md-6 col-lg-3 mb-4">
                <div className="text-center">
                    <div className="text-primary mb-3">
                     
                        <i className="fas fa-users fa-2x"></i>
                    </div>
                    <h4 className="font-weight-600 mb-2">Collaboration</h4>
                    <p className="text-3 mb-0">Partnering deeply with your team for measurable, shared success.</p>
                </div>
            </div>
            
        </div>
    </div>
</section>
        {/* Team Section */}
        {/* <section className="section bg-light">
          <div className="container">
            <div className="row">
              <div className="col-lg-8 mx-auto text-center mb-5">
                <h2 className="font-weight-600 mb-3">Meet Our Team</h2>
                <hr className="heading-separator-line border-primary border-2 d-block mx-auto" />
                <p className="text-3">Our talented team of experts brings together diverse skills and experience</p>
              </div>
            </div>
            <div className="row">
              <div className="col-md-6 col-lg-3 mb-4">
                <div className="bg-white rounded shadow-sm overflow-hidden">
                  <img src="https://images.unsplash.com/photo-1560250097-0b93528c311a?w=400&h=400&fit=crop" alt="Team Member" className="img-fluid" />
                  <div className="p-4 text-center">
                    <h5 className="font-weight-600 mb-1">John Doe</h5>
                    <p className="text-muted mb-0">CEO & Founder</p>
                  </div>
                </div>
              </div>
              <div className="col-md-6 col-lg-3 mb-4">
                <div className="bg-white rounded shadow-sm overflow-hidden">
                  <img src="https://images.unsplash.com/photo-1573496359142-b8d87734a5a2?w=400&h=400&fit=crop" alt="Team Member" className="img-fluid" />
                  <div className="p-4 text-center">
                    <h5 className="font-weight-600 mb-1">Jane Smith</h5>
                    <p className="text-muted mb-0">CTO</p>
                  </div>
                </div>
              </div>
              <div className="col-md-6 col-lg-3 mb-4">
                <div className="bg-white rounded shadow-sm overflow-hidden">
                  <img src="https://images.unsplash.com/photo-1519085360753-af0119f7cbe7?w=400&h=400&fit=crop" alt="Team Member" className="img-fluid" />
                  <div className="p-4 text-center">
                    <h5 className="font-weight-600 mb-1">Mike Johnson</h5>
                    <p className="text-muted mb-0">Lead Engineer</p>
                  </div>
                </div>
              </div>
              <div className="col-md-6 col-lg-3 mb-4">
                <div className="bg-white rounded shadow-sm overflow-hidden">
                  <img src="https://images.unsplash.com/photo-1580489944761-15a19d654956?w=400&h=400&fit=crop" alt="Team Member" className="img-fluid" />
                  <div className="p-4 text-center">
                    <h5 className="font-weight-600 mb-1">Sarah Williams</h5>
                    <p className="text-muted mb-0">Project Manager</p>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </section> */}

        {/* CTA Section */}
      <section
  className="section bg-primary text-white"
  style={{
   backgroundImage: "url('/images/projects/AH.jpg')",
    backgroundSize: 'cover',
    backgroundPosition: 'center',
    backgroundRepeat: 'no-repeat'
  }}
>
  <div className="container">
    <div className="row align-items-center">
      <div className="col-lg-8 mb-4 mb-lg-0">
<h1
  className="font-weight-600 mb-2"
  style={{ color: "white" }}
>
  Ready to Transform Your Business?
</h1>

        <p className="lead mb-0">Let's discuss how we can help you achieve your goals</p>
      </div>
      <div className="col-lg-4 text-lg-right">
        <a href="/contact" className="btn btn-light btn-lg rounded-pill">GetStarted</a>
      </div>
    </div>
  </div>
</section>

      </div>
      <Footer />
    </div>
  );
};

export default AboutPage;
